import { PRODUCT } from '../actions';
const initialState = {
  productFetching: false,
  data: null,
  productError: false,
  productDataError: null,
  dialogStock: false,
  dialogReview: false,
  category: null,
  // productReviewFetching: false,
  // productReview: null,
  addProductReviewFetching: false
};

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case PRODUCT.GET_ITEM_BY_ID_PENDING:
      return { ...state, productFetching: true };

    case PRODUCT.GET_ITEM_BY_ID_SUCCESS:
      return { ...state, productFetching: false, data: payload };

    case PRODUCT.GET_ITEM_BY_ID_FAILED:
      return {
        ...state,
        productFetching: false,
        productError: true,
        productDataError: error
      };

    case PRODUCT.OPEN_DIALOG_PRODUCT_OVER_STOCK:
      return { ...state, dialogStock: true };

    case PRODUCT.CLOSE_DIALOG_PRODUCT_OVER_STOCK:
      return { ...state, dialogStock: false };

    case PRODUCT.OPEN_DIALOG_PRODUCT_REVIEW:
      return { ...state, dialogReview: true };

    case PRODUCT.CLOSE_DIALOG_PRODUCT_REVIEW:
      return { ...state, dialogReview: false };

    case PRODUCT.CLEAR:
      return { ...state, data: null };

    case PRODUCT.ASSIGN_CATEGORY:
      return { ...state, category: payload };

    // case PRODUCT.GET_REVIEW_PENDING:
    //   return { ...state, productReviewFetching: true };

    // case PRODUCT.GET_REVIEW_SUCCESS:
    //   return { ...state, productReviewFetching: false, productReview: payload };

    // case PRODUCT.GET_REVIEW_FAILED:
    //   return {
    //     ...state,
    //     productReviewFetching: false
    //   };

    case PRODUCT.ADD_REVIEW_PENDING:
      return { ...state, addProductReviewFetching: true };

    case PRODUCT.ADD_REVIEW_SUCCESS:
      return { ...state, addProductReviewFetching: false };

    case PRODUCT.ADD_REVIEW_FAILED:
      return {
        ...state,
        addProductReviewFetching: false
      };

    default:
      return state;
  }
};
